function AINotetakerHero() {
  return (
    <section className="section ai-notetaker-hero" id="ai-notetaker-hero" aria-label="AI Notetaker Hero">
      <div className="container">
        <div className="ai-notetaker-content">
          <p className="ai-notetaker-subtitle">AI-Powered Note Taking</p>

          <h1 className="h1 ai-notetaker-title">Transform Your Notes Into Action</h1>

          <p className="ai-notetaker-text">Capture, organize, and extract insights from your notes effortlessly.</p>

          <ul className="ai-notetaker-features">
            <li className="feature-item">
              <span className="feature-icon">✨</span>
              <span>Real-time notes capture</span>
            </li>
            <li className="feature-item">
              <span className="feature-icon">🔍</span>
              <span>Smart search</span>
            </li>
            <li className="feature-item">
              <span className="feature-icon">⚡</span>
              <span>AI-powered summarization</span>
            </li>
            <li className="feature-item">
              <span className="feature-icon">🔒</span>
              <span>Secure and private</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default AINotetakerHero;
